import { z } from 'zod';
import { socialVideoFormatSchema } from '../social-video-format-schema';

export const backfillSocialVideosV1RequestSchema = z.object({
  format: socialVideoFormatSchema.optional(),
  limit: z.number().optional(),
});

export type IBackfillSocialVideosV1Request = z.infer<typeof backfillSocialVideosV1RequestSchema>;
